export default __webpack_public_path__ + "static/media/imgfinder.3c985d70.jpg";